export default ({
  namespaced: true,
  state: {
    view: 'snackbarPlan',
    values: {text: '', color: 'info', dialog: false, timeout: 10000}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/snackbarPlan.js